export default {
    statisticFormBaseData: 'Daten',
    statisticFormDedicatedForms: 'Zugeordnete Formulare',
    statisticFormClass: 'Statistikformular-Klasse',
}